import { useState } from 'react';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

import { queryClient } from '@/lib/api';
import { signIn } from '@/lib/auth';

function SignInCard() {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: ({ code }) => {
      setBusy(true);
      signIn(code)
        .then(() => queryClient.invalidateQueries())
        .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)))
        .finally(() => setBusy(false));
    },
    onError: () => setError('Google sign-in was cancelled or failed'),
  });
  return (
    <div className="page">
      <div className="card empty">
        <div className="ic">🔒</div>
        <div style={{ fontWeight: 700, color: 'var(--ink)' }}>Compass Usage</div>
        <button
          type="button"
          className="btn pri"
          disabled={busy}
          onClick={() => {
            setError(null);
            login();
          }}
        >
          Sign in with Google
        </button>
        <div>Use your compassapp.ai Google account.</div>
        {error && <div role="alert">{error}</div>}
      </div>
    </div>
  );
}

export function SignIn({ clientId }: { clientId: string }) {
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <SignInCard />
    </GoogleOAuthProvider>
  );
}
